import { API_URL } from 'constants/config';
import callApi from 'utils/callApi';

/** 取得策略 */
export function getAiSMStrategyProfile(email) {
  return callApi(`${API_URL}/Strategy/GetAiSMStrtegyProfile?email=${email}`);
}

/** 取得自選策略 */
export function getUserMarketProfile(email) {
  return callApi(`${API_URL}/Strategy/GetUserMarketProfile?email=${email}`);
}

/** 刪除自選策略 */
export function deleteUserMarketProfile(email, idList) {
  return callApi(`${API_URL}/Strategy/DeleteUserMarketProfileList?email=${email}`, {
    method: 'POST',
    body: JSON.stringify(idList),
  });
}

/** 新增自選策略
 *
 *    目前自選上限應該是10個, 正常會 return 'Saved', 超過會是 'overlimit'
 */
export function addUserMarketProfile(email, id, strategyId) {
  return callApi(
    `${API_URL}/Strategy/AddUserMarketProfile?email=${email}&MarketName=${id}&StrategyProfileId=${strategyId}`,
    {
      method: 'POST',
    }
  );
}
